import type { TooltipProps as _TooltipProps } from "@chakra-ui/react";
import { forwardRef, Tooltip as _Tooltip } from "@chakra-ui/react";

export interface TooltipProps extends _TooltipProps {}

export const Tooltip = forwardRef<TooltipProps, "div">(({ children, ...props }, ref) => (
    <_Tooltip ref={ref} {...props}>
        {children}
    </_Tooltip>
));
